import {
  FaPencil,
  FaRegTrashCan,
  FaPlus,
  FaTimeline,
  FaXmark,
  FaHouse,
  FaFileLines,
  FaUserGroup,
  FaBahai,
  FaAngleRight,
  FaCircleDot,
  FaAngleDown,
  FaRegCircleUser,
  FaAngleLeft,
  FaEye,
  FaCheck,
  FaCar,
  FaEllipsisVertical,
  FaEyeSlash,
  FaFilter,
  FaFilterCircleXmark,
  FaMagnifyingGlass,
  FaPhone,
  FaEnvelope,
  FaPrint,
  FaRegCircle,
  FaRegCircleCheck,
  FaReceipt,
  FaFileExcel
} from "react-icons/fa6";
import { BiSolidUserBadge } from "react-icons/bi";
import { FaCalendarAlt, FaFemale, FaMale } from "react-icons/fa";
import { LiaSignOutAltSolid } from "react-icons/lia";
import { RiBarChartHorizontalLine } from "react-icons/ri";
import { RxCross1 } from "react-icons/rx";
import { MdClearAll, MdKeyboardDoubleArrowRight } from "react-icons/md";
import { CiImageOn } from "react-icons/ci";

export const DeleteIcon = FaRegTrashCan;
export const EditIcon = FaPencil;
export const ViewIcon = FaEye;
export const AddIcon = FaPlus;
export const TimelineIcon = FaTimeline;
export const CloseIcon = FaXmark;
export const HomeIcon = FaHouse;
export const FileIcon = FaFileLines;
export const GroupUserIcon = FaUserGroup;
export const SettingsIcon = FaBahai;
export const RightArrowIcon = FaAngleRight;
export const RightDoubleArrowIcon = MdKeyboardDoubleArrowRight;
export const LeftArrowIcon = FaAngleLeft;
export const DotIcon = FaCircleDot;
export const DownArrowIcon = FaAngleDown;
export const ProfileIcon = FaRegCircleUser;
export const LogoutIcon = LiaSignOutAltSolid;
export const BarIcon = RiBarChartHorizontalLine;
export const CrossIcon = RxCross1;
export const DoneIcon = FaCheck;
export const CarIcon = FaCar;
export const EllipsisVerticalIcon = FaEllipsisVertical;
export const EyeIcon = FaEye;
export const CloseEyeIcon = FaEyeSlash;
export const FilterIcon = FaFilter;
export const FilterClearIcon = FaFilterCircleXmark;
export const ClearAllIcon = MdClearAll;
export const SearchIcon = FaMagnifyingGlass;
export const ImageIcon = CiImageOn;
export const PhoneIcon = FaPhone;
export const FemaleIcon = FaFemale;
export const MaleIcon = FaMale;
export const EmailIcon = FaEnvelope;
export const IDIcon = BiSolidUserBadge;
export const CalendarIcon = FaCalendarAlt;
export const PrintIcon = FaPrint;
export const BlankCircleIcon = FaRegCircle;
export const FillCircleIcon = FaRegCircleCheck;
export const ReceiptIcon = FaReceipt;
export const ExportIcon = FaFileExcel;

